import type { TrainingProgressStorePayload } from '../types/api';

export const TRAINING_PROGRESS_ENDPOINT = '/training-progress';
export const TRAINING_PROGRESS_VERSION = 1;

export interface TrainingProgressRequestBody {
  version: number;
  progress: TrainingProgressStorePayload;
}

export function buildTrainingProgressRequestBody(
  progress: TrainingProgressStorePayload
): TrainingProgressRequestBody {
  return {
    version: TRAINING_PROGRESS_VERSION,
    progress,
  };
}
